export default __webpack_public_path__ + "static/media/169.24b219cd.gif";